<template>
  <div v-if="currentAbsence">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Absences'"
          :description="'Aperçu d\'une absence'"
        />
      </div>

      <div class="col-lg-6 mt-lg-4">
        <div class="row" v-if="nettoyage">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 text-center font-weight-bold">Absence</td>
                </tr>
                <tr
                  v-if="chantier"
                  class="d-flex font-size-17 font-weight-bold"
                >
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Chantier :</span
                    ><span>
                      <a
                        style="cursor: pointer"
                        @click.prevent="
                          $router.push({
                            name: chantierRoutes.show,
                            params: { id: chantier.id },
                          })
                        "
                        title="Aperçu chantier"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                        <u class="text-custom-primary"> {{ chantier.nom }}</u>
                      </a>
                    </span>
                  </td>
                </tr>
                <tr
                  v-if="nettoyage"
                  class="d-flex font-size-17 font-weight-bold"
                >
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Date absence :</span
                    ><span>
                      {{ nettoyage.date }}
                    </span>
                  </td>
                </tr>
                <tr
                  v-if="nettoyage"
                  class="d-flex font-size-17 font-weight-bold"
                >
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Type absence :</span
                    ><span>
                      {{ currentAbsence.type_absence }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router
              .push({
                name: nettoyageRoutes.showAbsence,
                params: { id: nettoyage.id },
              })
              .catch(() => {})
          "
        >
          Liste des absences
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="newAbsence()"
        >
          <i class="fas fa-plus"></i>
          Signaler une absence
        </button>
        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="editAbsenceModal(currentAbsence.id)"
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: routes.show,
                params: { id: currentAbsence.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Absence
            </b-nav-item>

            <b-nav-item
              :to="{
                name: routes.showDocument,
                params: {
                  documentUuid: currentAbsence.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents
            </b-nav-item>
          </b-nav>
        </div>
      </div>

      <!--Absence modal -->
      <absence-modal
        :edit="modeDisplay === 'edit'"
        :employes="employes"
        :equipe="equipe"
        :modalTitle="titleModalAbsence"
        :type_absences="type_absences"
        :propForm="form"
        :modalID="modalAbsence"
        @submit="submitAbsence"
        @closeModal="closeModal"
      />

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import URL from '@/http/absence';
import NETTOYAGE_URL from '@/http/nettoyage';
import AbsenceModal from '../components/AbsenceModal.vue';
import names from '@/constants/routes/chantier/absence';
import nettoyageNames from '@/constants/routes/chantier/planning';
import chantierNames from '@/constants/routes/chantier/chantier';
import From from 'vform';

export default {
  components: {
    AbsenceModal,
  },
  data() {
    return {
      form: new From({
        commentaire: '',
        emplye: null,
        remplacant: null,
        type_absence: null,
      }),
      equipe: [],
      employes: [],
      type_absences: [],

      title: 'Gestion des absences - Aperçu',
      routes: names,
      nettoyageRoutes: nettoyageNames,
      chantierRoutes: chantierNames,

      modeDisplay: 'create',
      titleModalAbsence: 'Ajout de nouvelle absence',
      modalAbsence: 'modal-absence',
    };
  },
  computed: {
    ...mapGetters('absence', ['currentAbsence', 'chantier', 'nettoyage']),
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('absence', ['getAbsence']),
    init() {
      this.getAbsence({ id: this.$route.params.id });
    },

    async newAbsence() {
      await window.axios
        .get(NETTOYAGE_URL.GET_ABSENCE_REQUIREMENTS(this.nettoyage.id))
        .then((resp) => {
          this.employes = resp.data.employes;
          this.type_absences = resp.data.type_absences;
          this.equipe = resp.data.equipe;
        });
      this.modeDisplay = 'create';
      this.titleModalAbsence = 'Ajout de nouvelle absence';
      this.form.reset();
      this.form.clear();

      await this.$bvModal.show(this.modalAbsence);
    },
    async editAbsenceModal(id) {
      this.titleModalAbsence = "Edition d'une absence";
      this.form.reset();
      this.form.clear();
      this.modeDisplay = 'edit';

      await window.axios
        .all([
          window.axios.get(URL.ABSENCE + '/' + id, { params: { edit: true } }),
          window.axios.get(
            NETTOYAGE_URL.GET_ABSENCE_REQUIREMENTS(this.nettoyage.id),
            {
              params: { edit: true },
            }
          ),
        ])
        .then(
          window.axios.spread((resp, resp2) => {
            // Object.assign(this.form, resp.data.horaire);
            let data = resp.data.absence;
            this.form.id = data.id;
            this.form.employe = data.employe;
            this.form.remplacant = data.remplacant;
            this.form.type_absence = data.type_absence;
            this.form.commentaire = data.commentaire;

            this.employes = resp2.data.employes;
            this.type_absences = resp2.data.type_absences;

            this.equipe = resp2.data.equipe;
          })
        )
        .catch();

      await this.$bvModal.show(this.modalAbsence);
    },
    submitAbsence(form) {
      if (form.id) {
        //update
        form
          .put(URL.ABSENCE + '/' + form.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);
            this.reset();
            this.$bvModal.hide(this.modalAbsence);
            this.init();
          })
          .catch((err) => {
            form.errors.set('message', err.response.data.message);
            this.$bvModal.show(this.modalAbsence);
          })
          .finally(() => {
            this.form = form;
          });
      } else {
        //store
        form
          .post(NETTOYAGE_URL.ABSENCE(this.nettoyage.id))
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);
            this.$bvModal.hide(this.modalAbsence);
            form.reset();
            form.clear();
            this.$router.push({
              name: this.nettoyageRoutes.showAbsence,
              params: { id: this.nettoyage.id },
            });
          })
          .catch((err) => {
            form.errors.set('message', err.response.data.message);
            this.$bvModal.show(this.modalAbsence);
          })
          .finally(() => {
            this.form = form;
          });
      }
    },
    reset() {
      this.form.reset();
      this.form.clear();
    },
    closeModal() {
      this.reset();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
